import { ApiExerciseBaseItem, ApiExerciseAction } from "@tt-app/models/exercise";

export const getIfExerciseAction = (item: ApiExerciseBaseItem): ApiExerciseAction | undefined => {
  return item.type === "SHOW_END_BUTTONS" ||
    item.type === "SHOW_REVIEW" ||
    item.type === "SHOW_START_BUTTONS" ||
    item.type === "SHOW_TROPHY"
    ? (item as ApiExerciseAction)
    : undefined;
};

export const isNonTrophyAction = (item: ApiExerciseBaseItem): boolean => {
  return (
    item.type === "SHOW_START_BUTTONS" ||
    item.type === "SHOW_END_BUTTONS" ||
    item.type === "SHOW_REVIEW"
  );
};
